import React from 'react';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import InputSearch from '../InputSearch';
import s from './ElectionScheduleWrapper.scss';
import Link from '../../../components/Link/Link';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import {
  filterSearchSortData,
  loadYearWiseScheduleData,
} from '../../../routes/newslisting/redux';
import HeaderTab from '../../../routes/home/components/desktop/HeaderTabV2/HeaderTab';
import {
  AccordionItem,
  AccordionWithChild,
} from '../AccordionWithChild/AccordionWithChild';
import Morebtn from '../../desktop/Morebtn';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';
import { TOI_LIVE_DOMAIN } from '../../../constants';
import { createSlug } from '../../../utils/common';

class ElectionScheduleWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: { alpha: 1, key: 'sn' },
      searches: {},
      activeTabObject: this.props.phases?.slice(0, 1) || [],
    };
    this.phaseNameMapping = {
      dtOfNoti: 'Date Of Issue Of Gazette Notification',
      ldtOfFilingNom: 'Last Date Of Nominations',
      secOfNom: 'Date For Scrutiny Of Nominations',
      lastDateForWithdrawal: 'Last Date For Withdrawal Of Candidatures',
      dateofPolling: 'Polling Date',
      dateofResults: 'Result Date',
    };
    this.statesWithAndMapping = {
      'andaman-nicobar-islands': 'andaman-and-nicobar-islands',
      'jammu-kashmir': 'jammu-and-kashmir',
      'daman-diu': 'daman-and-diu',
      'dadra-nagar-haveli': 'dadra-and-nagar-haveli',
      'nct-of-delhi': 'delhi',
    };
    this.filterData2 = { ...this.props.filteredData } || {};
    try {
      const { electionData } = props?.sectionItem?.items || {};
      const liveData =
        Object.values(electionData) &&
        Array.isArray(Object.values(electionData)) &&
        Object.values(electionData).filter(data => data.live);
      if (liveData && Array.isArray(liveData) && liveData.length) {
        const { live, source } = Object.values(electionData).filter(
          data => data.live,
        )[0];
        this.state.live = live;
        this.state.source = source;
        this.state.selectedYear = Object.values(electionData).sort(
          (a, b) => b.year - a.year,
        )[0].year;
      }
    } catch (error) {
      //
    }
  }

  debounce = (func, delay) => {
    let timerId;
    return (...args) => {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  debouncedSearch = this.debounce(searches => {
    this.props.filterData(searches, this.state.sort, true);
  }, this.DEBOUNCE_DELAY);

  handleSearchChange = e => {
    const term = e.target.value;
    this.setState(
      {
        searches: {
          ...this.state.searches,
          'sn#cns_name': term,
        },
      },
      () => {
        this.debouncedSearch(this.state.searches);
      },
    );
  };

  onTabsChange = params => {
    const { year, live, source } = params.clickedItem;
    const { electionData } = this.props.sectionItem.items;
    this.setState({ selectedYear: year, live, source });
    this.props.loadAjaxElectionData(
      electionData[year],
      this.state.searches,
      this.state.sort,
      true,
    );
  };

  changeCricketTabs = item => {
    this.setState({ activeTabObject: item }, () => {});
    if (item && Array.isArray(item) && item.length && item[0]?.name) {
      this.tabRefs[item[0].name].current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  };

  renderTabs = (list, currentActiveTab, conditionToShow) =>
    conditionToShow && (
      <div className={`${s.tabList}`}>
        {list &&
          list.map((item, index) => (
            <div
              key={index}
              ref={this.tabRefs[item.name]}
              onClick={() => {
                this.changeCricketTabs([list[index]]);
              }}
              className={
                currentActiveTab &&
                currentActiveTab.some(obj => obj.name === item.name)
                  ? `${s.tabItem} ${s.active}`
                  : `${s.tabItem}`
              }
            >
              {item.name}
            </div>
          ))}
      </div>
    );

  render() {
    const { filteredData, phases } = this.props;
    this.tabRefs = phases.reduce((acc, tab) => {
      acc[tab.name] = React.createRef();
      return acc;
    }, {});
    const { electionData } = this.props.sectionItem.items;
    const currentActiveTab = this.state.activeTabObject;
    const slideIndex =
      phases instanceof Array &&
      phases.findIndex(
        st =>
          typeof st !== 'undefined' &&
          currentActiveTab &&
          st.name === currentActiveTab[0].name,
      );
    if (slideIndex > -1 && this.slider) {
      this.slider.slickGoTo(slideIndex);
    }
    const settings = {
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      beforeChange: (current, next) => {
        this.changeCricketTabs([phases[next]], false);
      },
    };
    return (
      <section className={s.schedulWrapper}>
        <div className={s.tabWrap}>
          <span className={s.tabWrapText}>Elections Schedule</span>
          <div className={s.tabs}>
            <span>Years : </span>
            <HeaderTab
              subSections={Object.values(electionData)
                .filter(ed => ed.scheduleUrl)
                .sort((a, b) => b.year - a.year)
                .map(ed => ({
                  ...ed,
                  url: ed.scheduleUrl,
                  link: ed.scheduleUrl,
                }))}
              onChangeCallback={this.onTabsChange}
            />
          </div>
        </div>
        {this.props.dataLoading && <LoaderSpinner />}
        <div className={s.schedulInfoHeader}>
          <p>
            <label>Total</label> Phases: <span>{phases.length}</span>
          </p>
          <p>
            <label>Total</label> States:{' '}
            <span>{Object.keys(this.filterData2).length}</span>
          </p>
          <p>
            <label>Total</label> Seats:{' '}
            <span>{this.props.fullData.constituencies.length}</span>
          </p>
        </div>
        {this.renderTabs(this.props.phases, this.state.activeTabObject, true)}
        <Slider
          {...settings}
          className="slick_UI"
          ref={slider => {
            this.slider = slider;
          }}
        >
          {this.props.phases &&
            Array.isArray(this.props.phases) &&
            this.props.phases.length &&
            this.props.phases.map(phase => (
              <div className={`${s.nationalSchedualTableWrap} ${s.boxStyle}`}>
                {this.phaseNameMapping &&
                  Object.keys(this.phaseNameMapping).map(key => (
                    <div className={s.nsRow}>
                      <span className={s.nsCol}>
                        {this.phaseNameMapping[key]}
                      </span>
                      <span className={s.nsCol}>{phase[key]}</span>
                    </div>
                  ))}
              </div>
            ))}
        </Slider>
        <Listingheader headingname="State wise Schedule" />
        <InputSearch
          placeholder="Search your Lok Sabha states/constituencies"
          searchHandler={this.handleSearchChange}
        />
        <div className={`${s.accordianWrap} ${s.boxStyle}`}>
          {filteredData &&
            Object.keys(filteredData).length > 0 && (
              <AccordionWithChild>
                {filteredData &&
                  Object.keys(filteredData).length &&
                  Object.keys(filteredData).map(stateName => (
                    <AccordionItem title={stateName}>
                      <div className={s.accordionItem}>
                        {filteredData[stateName] &&
                          Object.keys(filteredData[stateName]).map(
                            phaseNumber => (
                              <>
                                <h3>
                                  Phase {phaseNumber || ''}:{' '}
                                  <span>
                                    {phases[phaseNumber - 1]?.dateofPolling}
                                  </span>
                                </h3>
                                <div className={s.linkWrap}>
                                  {filteredData[stateName][phaseNumber] &&
                                    Array.isArray(
                                      filteredData[stateName][phaseNumber],
                                    ) &&
                                    filteredData[stateName][phaseNumber]
                                      .length > 0 &&
                                    filteredData[stateName][phaseNumber].map(
                                      constituency => (
                                        <Link
                                          to={`/elections/lok-sabha-constituencies/${createSlug(
                                            constituency?.sn_seo,
                                          )}/${createSlug(
                                            constituency?.cns_name_seo,
                                          )}`}
                                        >
                                          {constituency.cns_name}
                                        </Link>
                                      ),
                                    )}
                                </div>
                              </>
                            ),
                          )}
                        {filteredData[stateName] &&
                          Object.values(filteredData[stateName]) &&
                          Array.isArray(
                            Object.values(filteredData[stateName]),
                          ) &&
                          Object.values(filteredData[stateName]).length > 0 &&
                          Object.values(filteredData[stateName])[0] &&
                          Array.isArray(
                            Object.values(filteredData[stateName])[0],
                          ) &&
                          Object.values(filteredData[stateName])[0].length >
                            0 &&
                          Object.values(filteredData[stateName])[0][0]
                            ?.sn_seo && (
                            <div className={s.btnWrap}>
                              <Morebtn
                                moreText="View map"
                                moreLink={`${TOI_LIVE_DOMAIN}/elections/constituency-map/${createSlug(
                                  Object.values(filteredData[stateName])[0][0]
                                    .sn_seo,
                                )}`}
                                redBrdr
                              />
                              <Morebtn
                                moreText="More details"
                                moreLink={`${TOI_LIVE_DOMAIN}/elections/${createSlug(
                                  Object.values(filteredData[stateName])[0][0]
                                    .sn_seo,
                                )}-lok-sabha-election`}
                                redbg
                              />
                            </div>
                          )}
                      </div>
                    </AccordionItem>
                  ))}
              </AccordionWithChild>
            )}

          {filteredData &&
            Object.keys(filteredData).length === 0 && (
              <div className={s.noDataFound}>
                No results match your search criteria. Please search again!
              </div>
            )}
        </div>
      </section>
    );
  }
}

const mapDispatchtoProps = dispatch => ({
  loadAjaxElectionData: (year, searches, sort, loader = false) => {
    dispatch(loadYearWiseScheduleData(year, searches, sort, loader));
  },
  filterData: (searches, sort, loader = false) => {
    dispatch(filterSearchSortData(searches, sort, loader, true));
  },
});

const mapStateToProps = state => ({
  filteredData: state.newslisting && state.newslisting.filteredData,
  fullData: state.newslisting && state.newslisting.fullData,
  phases: state?.newslisting?.fullData?.phases,
  dataLoading: state?.newslisting?.dataLoading,
});

ElectionScheduleWrapper.propTypes = {
  filteredData: PropTypes.objectOf({}),
  fullData: PropTypes.objectOf({}),
  phases: PropTypes.objectOf({}),
  dataLoading: false,
};
ElectionScheduleWrapper.defaultProps = {
  filteredData: {},
  fullData: {},
  phases: [],
  dataLoading: false,
};

export default connect(mapStateToProps, mapDispatchtoProps)(
  ElectionScheduleWrapper,
);
